import { Box, IconButton } from '@dhl-ui/components'
import { MenuIcon } from '@dhl-ui/icons'
import { usePage } from '../../../context'

export const HeaderMenu = () => {
  const { isOpen, isExpanded, setIsOpen, setIsExpanded } = usePage()

  const handleToggleOpen = () => {
    setIsOpen(!isOpen)

    // making sure we are expanded (scenario: from collapsed desktop to mobile view)
    if (!isExpanded) {
      setIsExpanded(true)
    }
  }

  return (
    <Box sx={{ displayPrint: 'none' }}>
      <IconButton aria-label="menu" size="small" onClick={handleToggleOpen} color="inherit" square>
        <MenuIcon />
      </IconButton>
    </Box>
  )
}
